import { clsx } from 'clsx';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    className?: string;
}

export const Heading1 = ({ children, className }: Props) => {
    return <h1 className={clsx('text-4xl leading-tight font-bold tracking-tight', className)}>{children}</h1>;
};
